import { render, staticRenderFns } from "./PersonalDetailsModal.vue?vue&type=template&id=20a76ae0&scoped=true"
import script from "./PersonalDetailsModal.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetailsModal.vue?vue&type=style&index=0&id=20a76ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a76ae0",
  null
  
)

export default component.exports